<template>
  <div class="d-inline-block" style="width: 100%">
    <!-- Date & Time Picker -->
    <b-input-group v-if="date && time" :prepend="prepend" :size="size">
      <b-form-input class="date-time-picker-button" :id="`date-time-picker-button-${uniqueId}`" v-if="date && time" v-bind:value="formatedDateTime" readonly v-bind:disabled="disabled"></b-form-input>
      <template #append>
        <b-input-group-text v-if="disabled !== true"  @click="showPopover=!showPopover"><b-icon icon="calendar" ></b-icon></b-input-group-text>
      </template>
    </b-input-group>
    <!-- Date or Time picker -->
    <b-input-group v-else :prepend="prepend" :size="size">
      <b-form-datepicker
          v-if="date && time === false"
          v-model="context.date"
          :size="size"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :locale="$t('lang.base')"
          placeholder="Select date"
          @input="updateValue"
          :disabled="disabled"
      ></b-form-datepicker>
      <b-form-timepicker
          class="no-icon"
          v-if="date === false && time"
          v-model="context.time"
          :size="size"
          placeholder="Select time"
          @input="updateValue"
          :locale="$t('lang.base')"
          :disabled="disabled"/>
    </b-input-group>

    <b-popover v-if="date && time && disabled !== true" custom-class="date-time-picker-popover" :target="`date-time-picker-button-${uniqueId}`"
               :show.sync="showPopover" triggers="focus" placement="bottom">
      <b-calendar v-model="context.date"  :locale="$t('lang.base')" @input="updateValue"></b-calendar>
      <b-time v-model="context.time"  locale="fr" @input="updateValue"></b-time>
    </b-popover>
  </div>
</template>
<script>
import i18n from '@/libs/i18n'

export default {
  name: 'dateTimePicker',
  props: {
    value: {
      required: false,
      default: null
    },
    date: {
      required: false,
      default: true
    },
    time: {
      required: false,
      default: true
    },
    timeOnly: {
      required: false,
      default: false
    },
    initialNowTime:{
      required: false,
      default: true
    },
    disabled:{
      type: Boolean,
      default: false
    },
    size:{
      type: String,
      default: 'lg'
    },
    prepend:{
      type: String,
      default: null
    }
  },
  watch: {
    value: {
      handler() {
        this.updateByInput(this.value)
      },
      immediate: true,
    },
  },
  data: () => ({
    uniqueId: 0,
    showPopover: false,
    context:{
      date: null,
      time: null,
    },
  }),
  created() {
    this.uniqueId = this._uid;
  },
  computed: {
    formatedDateTime(){
      let context = this.context
      // No value selected → show an empty field. Without this guard,
      // $moment(null) falls back to the CURRENT date/time, so a null value
      // (e.g. a client with no FTD yet) rendered as "now".
      if (context.date == null) {
        console.log("formatedDateTime: context.date is null")
        return '';
      }
      if (this.date !== false && this.time !== false) {
        let datePart = this.$moment(context.date)
            .format('YYYY-MM-DD')
        return this.$moment(datePart + ' ' + context.time, 'YYYY-MM-DD HH:mm')
            .format(this.$t('timeFormat.dateTime.format'))
      }
      return '';
    },
    dateTime() {
      let context = this.context
      if (this.date !== false && this.time !== false) {
        let datePart = this.$moment(context.date)
            .format('YYYY-MM-DD')
        return this.$moment(datePart + ' ' + context.time, 'YYYY-MM-DD HH:mm')
            .utc()
            .toServerDateTimeFormat()
      }
      if (this.date !== false) {
        return this.$moment(context.date)
            .toServerDateFormat()
      }
      if (this.time !== false && this.timeOnly !== true) {
        let todayDatePart = this.$moment()
            .format('YYYY-MM-DD')
        return this.$moment(todayDatePart + ' ' + context.time)
            .toServerTimeFormat()
      }
      if (this.time !== false && this.timeOnly === true) {
        return context.time
      }
      return null
    },

  },
  methods: {
    updateByInput(value) {
      if(this.hasNoChanges(value)){
        return
      }
      if(value == null && this.initialNowTime !== false){
        console.log("initialNowTime applied")
        let now = this.$moment().utc();
        value = this.date === false && this.time !== false && this.timeOnly === true ? now.format('HH:mm') : now.toServerDateTimeFormat();
      }
      if (value == null) {
        this.context = { date: null, time: null, }
      } else if (this.date !== false && this.time !== false) {
        let m = this.$moment.server(value)
        this.context = { date: m.format('YYYY-MM-DD'), time: m.format('HH:mm') }
      }else if (this.date !== false) {
        let m = this.$moment(value, 'YYYY-MM-DD')
        this.context = { date: m.format('YYYY-MM-DD'), time: null }
      }else if (this.time !== false && this.timeOnly !== true) {
        let m = this.$moment(value, 'HH:mm')
        this.context = { date: null, time: m.format('HH:mm') }
      }else {
        this.context = { date: null, time: value }
      }
    },
    hasNoChanges(){
      let currentValue = this.dateTime
      if(currentValue == null && this.value == null){
        return true
      }
      if(currentValue != null && this.value == null || currentValue == null && this.value != null){
        return false
      }
      if(this.date !== false && this.time !== false){
        return this.$moment.server(this.value).toServerDateTimeFormat() === currentValue
      }
      if(this.date !== false){
        return this.$moment(this.value, 'YYYY-MM-DD').toServerDateFormat() === currentValue
      }
      if(this.time !== false && this.timeOnly !== true){
        let todayDatePart = this.$moment().format('YYYY-MM-DD')
        return this.$moment.server(todayDatePart + ' ' + this.value).toServerTimeFormat() === currentValue
      }
      if(this.time !== false && this.timeOnly === true){
        return this.value === currentValue
      }
      return false
    },
    updateValue(){
      console.log('updateValue', this.dateTime)
      this.$emit('input', this.dateTime)
    }
  }
}
</script>


<style>
.date-time-picker-button.form-control[readonly]:not([disabled]){
  background-color: transparent;
  cursor: pointer;
}
.date-time-picker-popover.bs-popover-bottom > .arrow {
  display: none;
}
</style>